<template>
  <router-link class="items-container__item item" :class="{ 'add-new-item': item.isNewRoute }" :to="item.isNewRoute ? { name: 'add-landlord' } : { name: 'landlord', params: {id: item.id}}">
    <div class="item__row item__title">
      <span>{{ item.name }}</span>
    </div>

    <div v-if="!item.isNewRoute" class="item__statusbar"><span class="filling" style="width: 0%"></span></div>
    <div v-if="!item.isNewRoute" class="item__row item__subtitle">
      <span>
        <span>{{ item.address }}</span>
      </span>
    </div>
  </router-link>
</template>

<script>
export default {
  props: ['item'],
};
</script>



// WEBPACK FOOTER //
// src/components/landlords/ListItemTemplate.vue